const ContribVisualiser = require("./../Core/Simulator/contrib_prevusualize");

$(document).ready(function() {
    $('.enterprise-visualise-cdp-contrib-pdf').on('click', function () {
        let $form = $('form[name=app_user_registration]');
        let itemId = $(this).data('item-id');
        ContribVisualiser.visualiseCdpContribPdf($form, 'enterprise_visualise_cdp_contrib_pdf', itemId);
    });

});